import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { Maybe } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type LTLProfileType = 'Equipment' | 'Carrier' | 'Mode';

export interface LTLProfileOption {
  label: string;
  value: string;
  flag?: Maybe<string>;
  properties?: {
    inclusive?: boolean;
  };
}

export type GetLTLProfilesResponse = {
  profiles: LTLProfileOption[];
};

export async function getLTLProfiles(
  integrationId: number,
  type: LTLProfileType,
  isForceRefresh = true
): Promise<Result<GetLTLProfilesResponse, ApiError>> {
  try {
    const response = await axios.get<GetLTLProfilesResponse>(
      '/quote/ltl/profiles',
      {
        params: {
          integrationId,
          type,
          isForceRefresh,
        },
      }
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLTLProfiles' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get LTL profiles' });
    }

    return err({
      message: error.response?.data?.message || 'Failed to get LTL profiles',
    });
  }
}
